'use strict';

define('lib/transforms/series.latest',['../page-cache'], function (PageCache) {
  // This function simply waits for the original series data to be set in the
  // session and transform it in various ways.
  PageCache.await('series.raw').then(function (data) {
    var allSeries = data.seriesDepthOne.series;
    var latest = [];
    var foundSeries;
    var i;
    var s;

    // Presort the series so they are added in order
    function sortByName(a, b) {
      return a.series_name < b.series_name ? -1 : a.series_name > b.series_name ? 1 : 0;
    }

    allSeries.sort(sortByName);

    allSeries.forEach(function  (series) {
      // Year only contains the latest
      foundSeries = false;
      for (i = 0; i < latest.length; ++i) {
        s = latest[i];
        if (s.series_code === series.series_code) {
          foundSeries = true;

          if (s.year < series.year) {
            latest[i] = series;
          }
          break;
        }
      }

      if (!foundSeries) {
        latest.push(series);
      }
    });

    PageCache.set('series.latest', latest);
    return latest;
  });
});

